@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.gems.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.PluralStringResource
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.gems.resources/"

@delegate:ResourceContentHash(1_550_371_810)
internal val Res.plurals.gems_fal_count: PluralStringResource by lazy {
      PluralStringResource("plurals:gems_fal_count", "gems_fal_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 66),
      ))
    }

@delegate:ResourceContentHash(1_058_545_258)
internal val Res.plurals.gems_item_count: PluralStringResource by lazy {
      PluralStringResource("plurals:gems_item_count", "gems_item_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 77, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 77, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77, 59),
      ))
    }

@delegate:ResourceContentHash(-704_145_158)
internal val Res.plurals.gems_poem_count: PluralStringResource by lazy {
      PluralStringResource("plurals:gems_poem_count", "gems_poem_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 145, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 149, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137, 63),
      ))
    }

@delegate:ResourceContentHash(-598_858_886)
internal val Res.plurals.gems_poet_count: PluralStringResource by lazy {
      PluralStringResource("plurals:gems_poet_count", "gems_poet_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 213, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 217, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201, 63),
      ))
    }

@delegate:ResourceContentHash(-200_764_647)
internal val Res.plurals.gems_story_count: PluralStringResource by lazy {
      PluralStringResource("plurals:gems_story_count", "gems_story_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 289, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 285, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 265, 68),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainPlurals0Resources(map: MutableMap<String, PluralStringResource>) {
  map.put("gems_fal_count", Res.plurals.gems_fal_count)
  map.put("gems_item_count", Res.plurals.gems_item_count)
  map.put("gems_poem_count", Res.plurals.gems_poem_count)
  map.put("gems_poet_count", Res.plurals.gems_poet_count)
  map.put("gems_story_count", Res.plurals.gems_story_count)
}
